/* @flow */

import React from 'react';
import {useParams} from 'react-router-dom';

import SupplierInvoiceDetailsComponent from 'app/suppliers/invoiceDetails';
import WebsitePageComponent from 'components/websiteStructure/pages';

export default function SupplierInvoiceDetailsPage() {
  const {id} = useParams();

  return (
    <WebsitePageComponent noPaper noTitle>
      <SupplierInvoiceDetailsComponent invoiceId={id} />
    </WebsitePageComponent>
  );
}
